<template>
  <div>
    <!-- <div class="content-header">
      <div class="left">会员编辑</div>
      <div class="right"></div>
      <div class="bottom"></div>
    </div>-->
    <div style="position: relative">
      <Form
        ref="form"
        :model="UserData"
        :rules="rule"
        inline
        :label-width="100"
      >
        <FormItem prop="tel" label="客户账号:" class="fromitem">
          <Input
            v-model="UserData.tel"
            type="text"
            maxlength="11"
            :disabled="UserData.id ? true : false"
          ></Input>
        </FormItem>
        <FormItem prop="user_type" label="客户类型:" class="fromitem">
          <RadioGroup v-model="user_type" @on-change='selectTypeChange'>
            <Radio :label="0">会员</Radio>
            <Radio :label="1">经销商</Radio>
          </RadioGroup>
          <router-link :to="{name:''}" style="margin-left:10px">
            <span style="font-size:12px">查看区别</span>
          </router-link>
        </FormItem>
        <FormItem prop="shop_user_type_id" label="客户等级:" class="fromitem">
            <Select
            v-model="UserData.shop_user_type_id"
          >
             <Option v-for="(val,index) in ClientType" :value="val.id" :key="index" v-if="val.type==user_type">{{val.name}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="area" label="所在地区:" class="fromitem">
          <!-- <span>{{UserData.area}}</span> -->
          <al-selector
            :gutter="0"
            data-type="name"
            v-if="Show"
            searchable
            v-model="UserData.area"
            level="2"
          />
        </FormItem>
        <FormItem prop="email" label="电子邮箱:" class="fromitem">
          <Input v-model="UserData.email" type="text"></Input>
        </FormItem>
        <FormItem prop="birthday" label="生日:" class="fromitem">
          <!-- <Input v-model="UserData.birthday" type="text"></Input> -->
          <DatePicker
            type="date"
            placeholder="选择生日"
            v-model="UserData.birthday"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem prop="note" label="备注:" class="fromitem">
          <Input v-model="UserData.note" type="textarea"></Input>
        </FormItem>
        <FormItem
          prop="alias"
          label="单位名称:"
          class="fromitem"
          v-if="UserData.user_type == 1"
        >
          <Input v-model="UserData.alias" type="text"></Input>
        </FormItem>
        <FormItem
          prop="staff_id"
          label="所属业务员:"
          class="fromitem"
          v-if="UserData.user_type == 1"
        >
          <Select v-model="UserData.staff_id">
              <Option v-for="(val,key) in Staff" :value="val.id" :key="key">{{
                val.name
              }}</Option>
          </Select>
        </FormItem>
        <FormItem
          prop="pay_type"
          label="信用结算:"
          class="fromitem"
          v-if="UserData.user_type == 1"
        >
          <i-switch v-model="UserData.pay_type" :true-value='1' :false-value='0' :disabled="!UserData.user_type ? true : false" />{{UserData.pay_type==0?' 关闭':' 打开'}}
          <Input
            v-model="UserData.credit_line"
            style="width: 120px; margin:0 10px"
            placeholder="填写授信额度"
            type="number"
            v-if="UserData.pay_type == 1"
            :disabled="credit_line_status"
          ></Input>
          <Checkbox v-model="credit_line_status" v-if="UserData.pay_type == 1"
            >无限制</Checkbox
          >
          <div class="describe">可为经销商身份的会员提供先发货后结算的支付方式，不同于货到付款，信用结算可实现多笔订单后期统一结算，并可授权经销商的赊账额度</div>
        </FormItem>
      </Form>
      <div class="footer" style="text-align: right;">
        <Button style="margin-right: 10px" @click="cancelChange">取消</Button>
        <Button type="primary" @click="save">确定</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    UserData: {
      type: Object,
      default: {
        id: 0,
        tel: "",
        shop_user_type_id: 0,
        name: "",
        staff_id: 0,
        shop_id: 0,
        credit_line: null,
        pay_type: "0",
        shop_user_id: 0,
        area: [],
        email: "",
        birthday: "",
        note: "",
        credit_line_status: false,
        user_type: 0,
        alias: "",
      },
    },
    Show:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      // data: {},
      user_type:0,
      credit_line_status: false,
      selectAccountType: "",
      area: [],
      rule: {
        tel: [{ required: true, trigger: "blur",
            validator: (rule, value, callback) => {
              if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(value)) {
                callback(new Error("请填写正确的手机号码"));
                return false;
              }
              callback();
            },
        }],
        user_type:[
           {
            required: true,
            message: "请选择客戶类型",
            trigger: "blur",
            type: "number",
            validator: (rule, value, callback) => {
              callback();
            },
          },
        ],
        shop_user_type_id: [
          {
            required: true,
            message: "请选择客戶等级",
            trigger: "blur",
            type: "number",
          },
        ],
        area: [
          {
            required: true,
            message: "请选择所在地区",
            type: "array",
            trigger: "blur",
          },
        ],
        email:[
           {
            type:'email',
            message: "请填写正确的电子邮箱",
            trigger: "blur",
          },
        ],
        alias: [
          {
            required: true,
            message: "请填写单位名称",
            trigger: "blur",
          },
        ],
        // pay_type: [
        //   {
        //     required: true,
        //     message: "请选择结算方式",
        //     trigger: "change",
        //     type: "number",
        //   },
        // ],
      },
      ClientType: [],
      Staff: {},
    };
  },
  mounted() {},
  created() {
    this.getType();
    this.getStaff();
  },
  methods: {
    ...mapActions(["getClientType", "GetStaffList", "CustomerSaveUser"]),
    getType() {
      this.getClientType().then((res) => {
        let area = [
          {
          id: 0,
          name: '注册会员(无折扣)',
          type:0
          }
        ];
        res.data.map(item=>{
          let discount;
          if(item.discount==100){
            discount = '无折扣'
          }else{
            discount = item.discount/10+'折';
          }
          if(item.name == '注册经销商'){
            item.name ='注册经销商(无折扣)'
          }else{
            item.name=item.name+'('+discount+')'
          }
          area.push(item);
        })
        console.log('area',area )
        this.ClientType = area;
      });
    },
    getStaff() {
      this.GetStaffList({ l: 10000, p: 0 }).then((res) => {
        this.Staff = res.data;
      });
    },
    cancelChange() {
      this.$emit("cancelChange");
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) return false;
        if (this.UserData.area.length === 4) {
          this.UserData.area.splice(3, 1);
        }
        let data = {
          tel: this.UserData.tel,
          shop_user_type_id: this.UserData.shop_user_type_id,
          name: this.UserData.name,
          staff_id: this.UserData.staff_id,
          shop_id: this.UserData.shop_id,
          credit_line: this.UserData.credit_line,
          credit_line_status: this.credit_line_status ? 1 : 0,
          pay_type: this.UserData.pay_type,
          user_id: this.UserData.id,
          shop_user_id: this.UserData.shop_user_id,
          area: this.UserData.area.join(","),
          email: this.UserData.email,
          birthday: this.UserData.birthday,
          note: this.UserData.note,
          user_type: this.UserData.user_type,
          alias: this.UserData.alias,
        };
        if (
          data.pay_type == 1 &&
          !data.credit_line_status &&
          data.credit_line <= 0
        ) {
          this.$Message.error("请输入授信额度");
          return false;
        }

        this.CustomerSaveUser(data).then((res) => {
          if (!res.status) {
            this.$Message.error(res.msg);
            return false;
          }

          this.$Message.success(res.msg);
          this.$emit("successChange");
        });
      });
    },
    selectTypeChange() {
      this.UserData.user_type = this.user_type;
      if(this.user_type == 0){
        this.UserData.shop_user_type_id = 0
      }else{//经销商
        this.ClientType.map(item=>{
          if(item.name.indexOf('注册经销商')!=-1){
            this.UserData.shop_user_type_id = item.id
          }
        })
      }
    },
  },
  computed: mapGetters({}),
  watch: {
    UserData: {
      handler(n, o) {
        if (this.UserData.credit_line_status) this.credit_line_status = true;
        else this.credit_line_status = false;
        if (this.UserData.credit_line == 0) {
          this.UserData.credit_line = "";
        }
        if(this.UserData.area.length==0){
          this.UserData.area=[]
        }
        if(this.UserData.id==0){
          this.UserData.user_type = 0;
        }
        this.user_type = this.UserData.user_type?this.UserData.user_type:0;
      },
      // deep: 1,
    },
    credit_line_status: {
      handler(n, o) {
        if (this.credit_line_status) this.UserData.credit_line_status = 1;
        else this.UserData.credit_line_status = 0;
      },
      deep: 1,
    },
  },
};
</script>
<style lang='less' >
.footer {
  border-top: 1px solid #e8eaec;
  padding: 12px 0 0 0;
}
.fromitem {
  width: 95%;
}
@import "./index.less";
</style>
